import { isEmpty } from 'core/utils/general-utils'
import { FrequencyLimitsType } from '../dvbc/redux/types'
import { RfTuningLimitValues } from '../status/redux/types'

export function getIsPWRHealthy(frequency: string, value: number, frequencyLimits: FrequencyLimitsType) {
  if (isEmpty(frequencyLimits)) {
    return undefined
  }

  const thresholds = frequencyLimits.find((e: RfTuningLimitValues) => e.lf === frequency)

  if (!thresholds) {
    return undefined
  }

  const { above, below } = thresholds.pwr

  return (value < parseFloat(below) ||
    (above && value > parseFloat(above)))
    ? false
    : true
}

export function getIsBERHealthy(frequency: string, value: string, frequencyLimits: FrequencyLimitsType) {
  if (isEmpty(frequencyLimits)) {
    return undefined
  }

  const thresholds = frequencyLimits.find((e: RfTuningLimitValues) => e.lf === frequency)

  if (!thresholds) {
    return undefined
  }

  const { above, below } = thresholds.ber

  return (parseFloat(value) > parseFloat(below) ||
    (parseFloat(value) > parseFloat(above)))
    ? false
    : true
}

export function getCellStatusColor(isHealthy?: boolean) {
  if (isHealthy === undefined) {
    return 'is-default'
  }

  return isHealthy ? '' : 'is-danger'
}

export function getRowStatusColor(isPWRHealthy?: boolean, isBERHealthy?: boolean) {
  if (!isPWRHealthy || !isBERHealthy) {
    return 'is-danger'
  }

  return 'is-success'
}